interface Store {
  config: any;
  state: {
    start: string;
    end: string;
  };
}

export class Submit {
  private node: HTMLElement;
  private store: Store;

  constructor({ node, store }: { node: HTMLElement; store: Store }) {
    this.node = node;
    this.store = store;

    this.node.addEventListener('click', (e) => {
      e.preventDefault();

      const { start, end } = this.store.state;
      const { locale } = this.store.config;

      if (start && end) {
        const url = `${this.store.config.submitBaseUrl}${encodeURIComponent(
          start
        )}/${encodeURIComponent(end)}?hl=${locale}`;
        window.open(url, '_blank');
      } else {
        alert(this.store.config.msg.validError);
      }
    });
  }
}
